import { render, staticRenderFns } from "./commissionRecordsList.vue?vue&type=template&id=7ddd0800&scoped=true"
import script from "./commissionRecordsList.vue?vue&type=script&lang=js"
export * from "./commissionRecordsList.vue?vue&type=script&lang=js"
import style0 from "./commissionRecordsList.vue?vue&type=style&index=0&id=7ddd0800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd0800",
  null
  
)

export default component.exports